var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainWrapper", attrs: { id: "top" } },
    [
      _c("head-nav", { attrs: { gray: _vm.gray, pos: "fixed" } }),
      _vm._v(" "),
      _c("div", { staticClass: "innerWrapper" }, [
        _c("h1", [_vm._v("Construction updates")]),
        _vm._v(" "),
        _c("div", { staticStyle: { padding: "0 0.24rem" } }, [
          _c(
            "div",
            { staticClass: "otherWrapper" },
            _vm._l(_vm.datum, function(con, ix) {
              return _c("div", { key: ix, staticClass: "other" }, [
                _c("div", { staticClass: "top" }, [
                  _c("div", { staticClass: "tit" }, [
                    _c("h3", [_vm._v(_vm._s(con.title))]),
                    _vm._v(" "),
                    _c("h4", [_vm._v("Posted " + _vm._s(con.createTime))])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "middle",
                    staticStyle: { "margin-top": "1rem" }
                  },
                  [
                    _vm._l(con.imgLst, function(img, i) {
                      return _c("li", {
                        key: i,
                        style: { backgroundImage: "url(" + img + ")" }
                      })
                    }),
                    _vm._v(" "),
                    con.imgLst && con.imgLst.length > 5
                      ? _c(
                          "div",
                          {
                            staticClass: "more",
                            on: {
                              click: function($event) {
                                return _vm.toDtl(con.constructionId)
                              }
                            }
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "+ " + _vm._s(con.imgLst.length - 4) + " More"
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "bom" }, [
                  _c("p", { domProps: { innerHTML: _vm._s(con.description) } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "link",
                      on: {
                        click: function($event) {
                          return _vm.toDtl(con.constructionId)
                        }
                      }
                    },
                    [_vm._v("\n              VIEW FULL UPDATE\n            ")]
                  )
                ])
              ])
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f6aa9b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f6aa9b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/private/construction/list.vue
// module id = null
// module chunks = 